import { Modal, ModalOverlay, ModalContent, ModalBody } from "@chakra-ui/react";

export default function Loading({ loadingShow }) {
  return (
    <>
      <Modal isOpen={loadingShow} className="search_loading_modal">
        <ModalOverlay />
        <ModalContent className="search_loading">
          <ModalBody>
            <>
              <div
                className="ajax-loader flex-center"
                // style={{ backgroundColor: "gray" }}
              >
                <p id="loader_text">
                  <span>
                    <img
                      src="/images/loading_bar_red.gif"
                      alt="판다파츠 로딩바"
                      className="load_partner-img"
                    />
                  </span>
                </p>
              </div>
            </>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
